export interface DelegateEvent {
  originalEvent: Event;
  delegateTarget: HTMLElement;
}
type CallbackFunction = (e: DelegateEvent) => void;
/**
 * Delegate Event Listener.
 *
 * 1. Finds the closest element to the event target that matches the target selector.
 * 2. If the target selector matches, the event target is returned.
 * 3. If not, null is returned.
 * 4. A DelegateEvent is created, with the original event, and the delegate target.
 * 5. The callback function is called with the new event.
 */
export default function (
  container: HTMLElement | Document,
  event: string,
  target: string,
  callback: CallbackFunction,
  eventOptions: boolean | AddEventListenerOptions = undefined
) {
  container.addEventListener(
    event,
    (e) => {
      // SVG icon clicks yield SVGElement, not HTMLElement
      if (!(e.target instanceof Element)) return;
      const matched = (e.target as Element).closest(target) as HTMLElement | null;
      if (matched === null) return;
      let newEvent: DelegateEvent = { originalEvent: e, delegateTarget: matched };
      callback(newEvent);
    },
    eventOptions
  );
}
